import { EnvironmentOutlined, TeamOutlined, UserOutlined, ForkOutlined } from "@ant-design/icons-vue";

import WebphoneIcon from "@/app/shared/components/icons/WebphoneIcon.vue";
import EmailIcon from "@/app/shared/components/icons/EmailIcon.vue";
import CreditCardIcon from "@/app/shared/components/icons/CreditCardIcon.vue";
import TypificationsIcon from "@/app/shared/components/icons/TypificationsIcon.vue";
import ContactsIcon from "@/app/shared/components/icons/ContactsIcon.vue";
import ProductsIcon from "@/app/shared/components/icons/ProductsIcon.vue";

import { ImportType } from "@/app/imports/utils/enums";

export const clientOptions = [
  {
    title: "Teléfonos",
    description:
      "Agrega el número de teléfono de tus contactos aquí. Puedes añadir cuantos números fijos o celulares necesites a un mismo contacto.",
    type: ImportType.Phones,
    icon: WebphoneIcon,
  },
  {
    title: "Direcciones",
    description:
      "Agrega las direcciones de tus contactos. Puedes añadir cuantas direcciones  necesites a un mismo contacto.",
    type: ImportType.Addresses,
    icon: EnvironmentOutlined,
  },
  {
    title: "Correos",
    description:
      "Agrega las direcciones de correo electrónico de tus contactos. Puedes añadir cuantos correos  necesites a un mismo contacto.",
    type: ImportType.Emails,
    icon: EmailIcon,
  },
  {
    title: "Referidos",
    description:
      "Agrega información personal sobre familiares o amigos de tu contacto, para tener una conexión alternativa ante cualquier emergencia.",
    type: ImportType.Contacts,
    icon: TeamOutlined,
  },
  {
    title: "Pagos",
    description:
      "Agrega información sobre los pagos de tus contactos. Esta información estará asociada directamente a los productos previamente importados.",
    type: ImportType.Payments,
    icon: CreditCardIcon,
  },
  {
    title: "Tipificaciones externas",
    description:
      "Agrega un historial o registro de las tipificaciones realizadas previamente a tu contacto. Esta información estará vinculada a la información de tickets.",
    type: ImportType.ExternalTypifications,
    icon: TypificationsIcon,
  },
];

export const otherOptions = [
  {
    title: "Activar / Inactivar contactos",
    description: "Podrás elegir si activar o inactivar contactos previamente importados a tu CRM.",
    type: [ImportType.ActiveClients, ImportType.InactiveClients],
    icon: ContactsIcon,
  },
  {
    title: "Activar / Inactivar productos",
    description: "Podrás elegir si activar o inactivar productos previamente importados a tu CRM.",
    type: [ImportType.ActivateAccounts, ImportType.InactivateAccounts],
    icon: ProductsIcon,
  },
  {
    title: "Activar / Inactivar teléfonos",
    description: "Podrás elegir si activar o inactivar teléfonos previamente importados a tu CRM.",
    type: [ImportType.ActivatePhones, ImportType.InactivatePhones],
    icon: WebphoneIcon,
  },
  {
    title: "Asignación de Usuarios",
    description:
      "Asigna contactos específicos a tus usuarios. Según tu configuración en Campañas, estos tendrán prioridad sobre los contactos en sus gestiones.",
    type: ImportType.AgentsAssignment,
    icon: UserOutlined,
  },
  {
    title: "Asignar contactos a secuencias",
    description:
      "Carga los contactos que deseas asignar a tus secuencias. Asegúrate de que el ID de la secuencia esté asociado a la campaña correspondiente.",
    type: ImportType.ContactsSequence,
    icon: ForkOutlined,
  },
];
